import { queryOptions } from "@tanstack/react-query";
import { getGeneratedBlogByBlueprintId } from 'src/common/Scraper';

/**
 * Generates the React Query options for fetching a generated blog post by blueprint ID.
 * 
 * @param blueprintId - The ID of the blueprint.
 * @returns Query options configuration for React Query.
 */
function getGeneratedBlogByBlueprint(blueprintId: string) {
  return queryOptions({
    queryKey: ['get-generated-blog-by-blueprint', blueprintId],
    queryFn: () => getGeneratedBlogByBlueprintId(blueprintId) as Promise<any>,
    enabled: !!blueprintId
  });
}

export default getGeneratedBlogByBlueprint;
